export default __webpack_public_path__ + "static/media/line8.fceaec0b.svg";